import React from 'react';

import TextField from '@mui/material/TextField';

import type { FieldValues } from './CreditScoreRegistrationModal';
import { useFormField } from './CreditScoreRegistrationModal';

type MemoTextFieldProps = {
  label: string;
  margin?: any;
  className?: string;
  sx?: object;
  fieldName: string;
  textFieldProps?: object;
  children?: React.ReactNode;
  select?: boolean;
  placeholder?: string;
  id?: string;
  variant?: any;
  type?: string;
  error?: boolean;
  autoComplete?: string;
  inputProps?: object;
  maxLength?: number;
  endAdornment?: React.ReactNode;
};

export default function MemoTextField(props: MemoTextFieldProps) {
  const {
    fieldName,
    textFieldProps,
    children,
    sx,
    select,
    label,
    margin,
    className,
    placeholder,
    id,
    variant,
    type,
    inputProps,
    maxLength,
    endAdornment = null,
  } = props as MemoTextFieldProps;

  const { value, onChange, helperText } = useFormField(fieldName as keyof FieldValues);

  return (
    <TextField
      id={id}
      value={value}
      helperText={helperText}
      error={helperText === '' || !!helperText}
      placeholder={placeholder}
      label={label}
      margin={margin}
      variant={variant}
      onChange={onChange}
      className={className}
      sx={sx}
      select={select}
      type={type}
      InputProps={{
        ...inputProps,
        endAdornment,
      }}
      inputProps={{
        maxLength,
      }}
      fullWidth
      {...textFieldProps}
    >
      {children}
    </TextField>
  );
}
